import { DropdownItem } from 'components/Dropdown/types'
import { Prediction } from '.'
import { ThemeColor } from 'utils/colors'

export const processPredictions = (predictions: Prediction[]): DropdownItem<string>[] =>
  predictions.map((i) => ({
    data: i,
    icon: ['far', 'location-dot'],
    iconColor: 'gray5' as ThemeColor,
    label: i.description,
    value: i.place_id,
  }))
